import { type InputHTMLAttributes } from 'react'

type InputProps = InputHTMLAttributes<HTMLInputElement | HTMLTextAreaElement> & {
  errorMessage?: string
  placeholder: string
  type?: 'input' | 'textarea'
}

export const ContactUsInput = ({
  errorMessage,
  placeholder,
  type = 'input',
  ...props
}: InputProps) => {
  return (
    <label>
      <div className="relative">
        {type === 'input' ? (

          <input
          {...props}
          placeholder={placeholder}
          className="h-10 py-2 px-4 w-full bg-[#f4f4f4] rounded-lg outline-none border-[#042F49] border-1 font-montserrat text-base font-medium text-[#7D7D7E] placeholder:text-[#7D7D7E] placeholder:font-montserrat placeholder:font-medium placeholder:text-base"
          />
        ) : (
            <textarea
            {...props}
            placeholder={placeholder}
            className="h-60 py-2 px-4 w-full bg-[#f4f4f4] rounded-lg outline-none border-[#042F49] border-1 font-montserrat text-base font-medium text-[#7D7D7E] placeholder:text-[#7D7D7E] placeholder:font-montserrat placeholder:font-medium placeholder:text-base"
            />
        )}
      </div>

      {errorMessage && (
        <p className="mt-2 text-[#FF4949] text-xs">{errorMessage}</p>
      )}
    </label>
  )
}
